module.exports = __webpack_public_path__ + "assets/out.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/out.svg
// module id = 1185
// module chunks = 7